export default "__VITE_ASSET__58bcd946__"